




















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class HandleChangesInBlueprintDialog extends Vue {
  @Prop({ default: () => ({}) })
  data!: any;

  get dependents() {
    if (this.data.dependents?.length > 5) {
      return this.data.dependents.splice(0, 5);
    }
    return this.data.dependents;
  }

  get stepName() {
    return (
      this.data.changes.old.stepLanguages?.find(
        (language: any) => language.languageId === this.$store.state.user.languageId
      )?.name || ''
    );
  }

  get moduleName() {
    return (
      this.data.changes.old.moduleLanguages?.find(
        (language: any) => language.languageId === this.$store.state.user.languageId
      )?.name || ''
    );
  }

  @Prop({ default: () => false })
  value?: boolean;
}
